import { SlotGameType1 } from "../SlotGameType1";
// import { ExpandingWildsBulkFactory , ExpandingWildsBulk , ExpandingWildsBulkParam } from "../../slot/ExpandingWildBulk";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { ImageResource } from "../../ResourceManager/ImageResource";
// import { Sprite } from "../Sprite/Sprite";
// import { SpriteResource } from "../../ResourceManager/SpriteResource";
// import { CanvasSprite } from "../Sprite/CanvasSprite";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";

// namespace SlotGames
// {
	export class JuicyIce extends SlotGameType1 
	{
		// override default factory with one that creates custom icy fresh freegame
		////protected override freegameBonusFactory: FreegameBonusFactory = new JuicyIceFreegameBonusFactory();
		protected override pickBonusFactory:PickBonusFactory = new JuicyIcePickBonusFactory();

		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) 
		{
			super(multigameParams, initData, "JuicyIce");
			this.spinnableReelsParams.topBorderWidth=10;
			this.spinnableReelsParams.bottomBorderWidth=6;
		}

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
	}
	



	/**
	 * PICK BONUS
	 */
	class JuicyIcePickBonus extends PickBonus
	{
		/* protected PicksPositions():PickBonusElemGeometry[]
		{
			let geometry: PickBonusElemGeometry[] = [];

			let displayWidth: number = 256;//285 * 0.60;
			let displayHeight: number = 261;//325 * 0.60;

			let displayRects: PixelRect[] = 
			[
				new PixelRect(86,14, displayWidth, displayHeight),
				new PixelRect(65,316, displayWidth, displayHeight),
				new PixelRect(38,649, displayWidth, displayHeight),
				new PixelRect(61,493, displayWidth, displayHeight),
				new PixelRect(80,163, displayWidth, displayHeight),
				new PixelRect(212,240, displayWidth, displayHeight),
				new PixelRect(230,91, displayWidth, displayHeight),
				new PixelRect(212,550, displayWidth, displayHeight),
				new PixelRect(205,402, displayWidth, displayHeight),
				new PixelRect(180,691, displayWidth, displayHeight),
				new PixelRect(344,655, displayWidth, displayHeight),
				new PixelRect(370,355, displayWidth, displayHeight),
				new PixelRect(361,171, displayWidth, displayHeight),
				new PixelRect(414,31, displayWidth, displayHeight),
				new PixelRect(499,239, displayWidth, displayHeight),
				new PixelRect(409,499, displayWidth, displayHeight),
				new PixelRect(518,698, displayWidth, displayHeight),
				new PixelRect(572,543, displayWidth, displayHeight),
				new PixelRect(556,381, displayWidth, displayHeight),
				new PixelRect(592,105, displayWidth, displayHeight),
				new PixelRect(661,209, displayWidth, displayHeight),
				new PixelRect(740,503, displayWidth, displayHeight),
				new PixelRect(725,661, displayWidth, displayHeight),
				new PixelRect(767,33, displayWidth, displayHeight),
				new PixelRect(793,187, displayWidth, displayHeight),
				new PixelRect(729,353, displayWidth, displayHeight),
				new PixelRect(898,535, displayWidth, displayHeight),
				new PixelRect(903,702, displayWidth, displayHeight),
				new PixelRect(1074,638, displayWidth, displayHeight),
				new PixelRect(1235,689, displayWidth, displayHeight),
				new PixelRect(1201,531, displayWidth, displayHeight),
				new PixelRect(1043,455, displayWidth, displayHeight),
				new PixelRect(1099,289, displayWidth, displayHeight),
				new PixelRect(970,181, displayWidth, displayHeight),
				new PixelRect(1363,521, displayWidth, displayHeight),
				new PixelRect(1527,679, displayWidth, displayHeight),
				new PixelRect(1382,665, displayWidth, displayHeight),
				new PixelRect(1588,534, displayWidth, displayHeight),
				new PixelRect(1425,383, displayWidth, displayHeight),
				new PixelRect(1251,381, displayWidth, displayHeight),
				new PixelRect(916,360, displayWidth, displayHeight),
				new PixelRect(1126,102, displayWidth, displayHeight),
				new PixelRect(965,27, displayWidth, displayHeight),
				new PixelRect(1581,364, displayWidth, displayHeight),
				new PixelRect(1571,200, displayWidth, displayHeight),
				new PixelRect(1412,220, displayWidth, displayHeight),
				new PixelRect(1248,218, displayWidth, displayHeight),
				new PixelRect(1281,36, displayWidth, displayHeight),
				new PixelRect(1596,42, displayWidth, displayHeight),
				new PixelRect(1436,57, displayWidth, displayHeight)
			];


			//
			//let pickRect = new PixelRect(displayWidth, displayHeight, displayWidth, displayHeight);
			//pick area
			let pickRect = new PixelRect(85, 91, 93, 87);
			

			//let awardRect = new PixelRect(64, 114, 66, 64);
			//award display area
			let awardRect = new PixelRect(81, 85, 87, 70);

			for (let i = 0; i < displayRects.length; i++) {
				geometry.push(new PickBonusElemGeometry(displayRects[i], pickRect, awardRect));
			}

			return geometry;

		} 
 */
		

	}

	class JuicyIcePickBonusElement extends PickBonusElement
	{
		public override AwardElemePrepare()
		{
			super.AwardElemePrepare();
			
			/* this.awardElem.style.left = this.awardRect.x +"px";
			this.awardElem.style.top = this.awardRect.y+10 + "px";
			this.awardElem.style.width = this.awardRect.width + "px";
			this.awardElem.style.height = this.awardRect.height + "px"; */
		}
		/* public WaitAnimPick()
		{
			this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 1}, {myscale: 1.2, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
		} */
	}

	class JuicyIcePickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus 
		{
			return new JuicyIcePickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement 
		{
			return new JuicyIcePickBonusElement(params);
		}
		
	}
	
// }
